export default class MemberAddonManager{
    constructor(purchased={},inUse={}){
        this.addons=[];
        this.selectedAddons=[];
        this.initialAddons=[];
        this.purchasedQty=purchased;
        this.in_use=inUse;
        this.email="";

        //modal
        this.modal=$("#manage-team-member-addons-modal");

        //member email shown
        this.memberEmailHtml=$("#member-addons-manager-email");
        this.addonsListHtml=$("#member-manager-addons-list");

        //buttons
        this.managerCancelButton=$("#cancel-team-member-addon-manager");
        this.managerConfirmButton=$("#confirm-team-member-addon-manager");
        this.managerCloseButton=$("#close-team-member-addon-manager");

    };

    showManager(member,closeOnSubmit=true){
        return new Promise((resolve,reject)=>{
            console.log("Showing manager with selected addons",this.selectedAddons);

            this.email=member;
            this.memberEmailHtml.html(this.email);
            
            this.managerCancelButton.off()
            this.managerConfirmButton.off();
            this.managerCloseButton.off();
            this.managerCancelButton.on('click',()=>{
                this.closeManager()
                reject();
            })
            this.managerCloseButton.on('click',()=>{
                this.closeManager()
                reject();
            });
            
            this.managerConfirmButton.on('click',()=>{
                this.disableSubmitButton();
                const selectedIds=this.getSelectedAddonIds();
                const selectedAddons=this.addons.filter(addon=>selectedIds.includes(addon.id));
                if(closeOnSubmit){
                    this.closeManager();
                }
                if(selectedAddons){
                    resolve(selectedAddons);
                    return
                }else{
                    reject()
                }
            })
            this.modal.modal('show');
        })
    }

    closeManager(){
        this.modal.modal('hide')
    }

    withAddons(addons=false,selectdAddonIds=[]){
        try {
            this.selectedAddons=selectdAddonIds;
            this.initialAddons=selectdAddonIds;
            this.setAddonsLoading();
            if(addons){
                this.addons=addons;
                this.renderAddons();
            }else{
    
            }
        } catch (error) {
            console.error(error)
        }
        return this;
    }

    renderAddons(){
        if(this.addons.length){
            this.addonsListHtml.html('');
            this.addons.forEach(addon=>{
                this.renderAddon(addon);
            });
            this.onSelectionChanged();
        }else{
            this.disableSubmitButton();
        }
    };

    renderAddon(addon){
        const manager=this;
        let availableQty=0;
        if(addon.type=='workspace'){return}
        let purchasedQty=this.purchasedQty[addon.id] ? this.purchasedQty[addon.id] : 0;
        let inUseQty=this.in_use[addon.id] ? this.in_use[addon.id] : 0;

        availableQty=purchasedQty - inUseQty;

        const addonQty=$("<span/>",{
            html:`(${availableQty < 0 ? '0' : availableQty})`
        })
        const addonName=$("<div/>",{
            class:'mui--text-subhead text-bold d-flex justify-content-between',
            html:[`${addon.name}`,addonQty]
        });

        const addonNameContainer=$("<div/>",{
            class:"plan-name-container",
            html:[addonName]
        });

        const labelBox=$("<label/>",{
            class:"label-custom-plans inline-addon-small plan-addon label-custom-plans-padding shadow-sm",
            for:'member-addon-'+addon.id,
            style:'min-height:100%',
            title: `Available (${availableQty < 0 ? '0' : availableQty})`,
            html:addonNameContainer
        });

        const checkbox=$("<input/>",{
            type:"checkbox",
            name:"member_manager_selected_addon",
            value:addon.id,
            id: 'member-addon-'+addon.id,
            class:"input billing-input plans-class-input",

        }).on('change',e=>{
            if(checkbox.is(':checked')){
                availableQty--;
            }else{
                availableQty++;
            }
            addonQty.html(`(${availableQty < 0 ? '0' : availableQty})`);
            labelBox.attr('title',`Available (${availableQty < 0 ? '0' : availableQty})`)
            this.onSelectionChanged();
        });

        if(this.selectedAddons.includes(addon.id)){
            checkbox.prop({checked:true});
        }
   
        const addonContent=$("<div/>",{
            class:'billing-method-radio radio-group plans-class-radio w-100',
            html:[checkbox,labelBox]
        });

        const addonRow=$("<div/>",{
            class:"col-md-12",
            html:addonContent
        });

        this.addonsListHtml.append(addonRow);
        
    };

    getSelectedAddonIds(){
        const selectedIds=[];
        this.addonsListHtml.find(`input[name='member_manager_selected_addon']`).each((i,checkbox)=>{
            // console.log(`${i},${checkbox}`)
            if($(checkbox).is(':checked')){
                selectedIds.push(parseInt($(checkbox).val()));
            }
        })
        return selectedIds
    };

    onSelectionChanged(){
        console.log("selected addons",this.getSelectedAddonIds());
        const selectedIds=this.getSelectedAddonIds();
        if(selectedIds.sort().toString() != this.initialAddons.sort().toString()){
            this.enableSubmitButton();
        }else{
            this.disableSubmitButton();
        }

    }


    disableSubmitButton(){
        this.managerConfirmButton.prop({disabled:true})
    }

    enableSubmitButton(){
        this.managerConfirmButton.prop({disabled:false})
    }

    setAddonsLoading(){
        this.addonsListHtml.html(`
            <div class="d-flex w-100 justify-content-center align-items-center loading-addons flex-column">
                <div class="spinner-grow text-secondary mb-3" style="width: 3rem; height: 3rem;" role="status">
                </div>
                <span>Loading add-ons...</span>
            </div>
        `);
    }
};